import { InputNumber } from 'antd';
import React, { useCallback, useEffect, useRef } from 'react';

const CurrencyInput = React.memo(
  React.forwardRef(({ value, onChange, ...props }, ref) => {
    const inputRef = useRef(null);

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.style.textAlign = "right";
        inputRef.current.style.paddingRight = "11px";
      }
    }, []);

    // Conectamos el ref externo con el interno (opcional pero útil)
    useEffect(() => {
      if (ref) {
        if (typeof ref === "function") {
          ref(inputRef.current);
        } else {
          ref.current = inputRef.current;
        }
      }
    }, [ref]);

    const formatterInstance = new Intl.NumberFormat("es-AR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    const formatInstance = useCallback((v) => {
      if (v == null || v === "") return "";
      return formatterInstance.format(v);
    }, []);

    const parseCurrency = useCallback((v) => {
      if (v == null || v === "") return "";
      return v.replace(/\$\s?/g, "").replace(/\./g, "").replace(",", ".");
    }, []);

    return (
      <InputNumber
        ref={inputRef}
        value={value}
        prefix="$"
        // formatter={formatInstance}
        // parser={parseCurrency}
        decimalSeparator={','}
        min={0}
        max={99999999999}
        precision={2}
        step={0.1}
        onChange={onChange}
        {...props}
      />
    );
  })
);

// const CurrencyInput = ({ value, onChange, ...props }) => {
//   const [tempValue, setTempValue] = useState(value);
//   const inputRef = useRef(null);

//   useEffect(() => {
//     setTempValue(value);
//   }, [value]);

//   const handlePressEnter = () => {
//     onChange?.(tempValue);
//   };

//   useEffect(() => {
//     if (inputRef.current) {
//       inputRef.current.style.textAlign = 'right';
//       inputRef.current.style.paddingRight = '11px';
//     }
//   }, []);

//   return (
//     <InputNumber
//       ref={inputRef}
//       value={tempValue}
//       onChange={setTempValue}
//       onPressEnter={handlePressEnter}
//       onBlur={handlePressEnter}
//       min={0}
//       max={99999999999}
//       step={0.1}
//       precision={2}
//       prefix="$"
//       decimalSeparator=","
//       {...props}
//     />
//   );
// };

export default CurrencyInput;